import React, { useState, useEffect, useRef } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import axiosConfig from "../../services/axiosConfig";
import setHeader from "../../components/Functions/setHeader";
import Breadcrumb from "../../components/common/breadcrumb";
import SweetAlert from "sweetalert2";
import { SITE_URL } from "../../services/Const";
import { useDispatch, useSelector } from "react-redux";
import { fetchActiveCurrencies } from "../../redux/ecommerce/currency/actions";

const OrderDetailsPage = () => {
  const location = useLocation();
  const orderData = location?.state?.selectedOrder;

  const {currencies} = useSelector(state => state.Currency);
  const dispatch = useDispatch()
  useEffect(() => {
    dispatch(fetchActiveCurrencies()); // must be called
  }, [dispatch]);

  const navigate = useNavigate();
  // const [orderData, setOrderData] = useState(null);
  const [selectedStatus, setSelectedStatus] = useState(parseInt(orderData?.order_status) || 0);

  const [statusLoading, setStatusLoading] = useState(false);

  const statusOptions = [
    { value: 1, label: "Accepted", color: "text-success", badge: "bg-success" },
    { value: 2, label: "Dispatch", color: "text-info", badge: "bg-info" },
    { value: 3, label: "Shipped", color: "text-primary", badge: "bg-primary" },
    { value: 4, label: "Delivered", color: "text-success", badge: "bg-success" },
    { value: 5, label: "Rejected", color: "text-danger", badge: "bg-danger" },
  ];

  // Function to get current status text
  const getCurrentStatusText = (statusCode) => {
    const statusMap = {
      0: "Pending",
      1: "Accepted",
      2: "Dispatch",
      3: "Shipped",
      4: "Delivered",
      5: "Rejected",
      6: "Return",
      7: "User Canceled"
    };
    return statusMap[statusCode] || "Unknown";
  };

  // Function to get status badge class
  const getStatusBadgeClass = (statusCode) => {
    const statusClasses = {
      0: "bg-warning text-dark",
      1: "bg-success",
      2: "bg-info",
      3: "bg-primary",
      4: "bg-success",
      5: "bg-danger",
      6: "bg-secondary",
      7: "bg-dark"
    };
    return statusClasses[statusCode] || "bg-light text-dark";
  };

  const handleStatusChange = (e) => {
    setSelectedStatus(parseInt(e.target.value));
  };

  const handleStatusUpdate = async () => {
    if (!orderData?.d_id) {
      SweetAlert.fire({
        title: "Error!",
        text: "Order ID is missing!",
        icon: "error",
        confirmButtonText: "OK"
      });
      return;
    }

    setStatusLoading(true);
    try {
      const response = await axiosConfig.get(
        `order-status-update/${orderData.d_id}/${selectedStatus}`,
        setHeader()
      );
      console.log(response.data);

      if (!response.data.error) {
        SweetAlert.fire({
          title: "Success!",
          text: "Order status updated successfully!",
          icon: "success",
          confirmButtonText: "OK"
        });
        navigate('/pages/orders')

      } else {
        throw new Error(response.data.messages || "Failed to update status");
      }
    } catch (error) {
      console.error("Error updating order status:", error);
      SweetAlert.fire({
        title: "Error!",
        text: error.response?.data?.messages || "Failed to update order status!",
        icon: "error",
        confirmButtonText: "OK"
      });
    } finally {
      setStatusLoading(false);
    }
  };

  const isStatusUpdateDisabled = () => {
    return (
      statusLoading ||
      selectedStatus === orderData?.order_status ||
      orderData?.order_status === 4 ||
      orderData?.order_status === 7 ||
      orderData?.order_status === 5
    );
  };

  if (!orderData) {
    return (
      <div className="container-fluid">
        <div className="row justify-content-center">
          <div className="col-12 text-center py-5">
            <h4>Order not found</h4>
            <button className="btn btn-primary mt-3" onClick={() => navigate("/pages/orders")}>
              Back to Orders
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="container-fluid">
      <Breadcrumb title="Order Details" parent="Orders" />

      {/* Header */}
      <div className="row mb-4">
        <div className="col-12">
          <div className="d-flex justify-content-between align-items-center">
            {/* <div>
              <h3 className="mb-0">Order #{orderData.order_id}</h3>
              <small className="text-muted">
                Order placed on {new Date(orderData.order_date).toLocaleDateString('en-GB', {
                  day: '2-digit',
                  month: 'long',
                  year: 'numeric',
                })}
              </small>
            </div> */}
            <button
              className="btn btn-secondary"
              onClick={() => navigate("/orders")}
            >
              Back to Orders
            </button>
          </div>
        </div>
      </div>

      <div className="row">
        {/* Order Information */}
        <div className="col-lg-8 mb-4">
          <div className="card shadow-sm">
            <div className="text-white p-3 card-header bg-light ">
              <h5 className="mb-0 text-black fw-bold">
                Order Information
              </h5>
            </div>
            <div className="card-body">
              <div className="row mb-3">
                <div className="col-md-6">
                  <strong>Order ID:</strong>
                  <span className="ms-2 badge bg-primary">#{orderData.order_id}</span>
                </div>
                <div className="col-md-6">
                  <strong>Order Date:</strong>
                  <span className="ms-2">
                    {new Date(orderData.order_date).toLocaleDateString('en-GB')}
                  </span>
                </div>
              </div>

              <div className="row mb-3">
                <div className="col-md-6">
                  <strong>Status:</strong>
                  <span className={`ms-2 badge ${getStatusBadgeClass(orderData.order_status)}`}>
                    {getCurrentStatusText(orderData.order_status)}
                  </span>
                </div>
                <div className="col-md-6">
                  <strong>Total Amount:</strong>
                  <span className="ms-2 h5 text-success">{currencies?.symbol} {orderData.amount}</span>
                </div>
              </div>

              <div className="row">

                <div className="col-md-6">
                  <strong>Product Code:</strong>
                  <span className="ms-2 font-monospace">{orderData.productCode}</span>
                </div>
              </div>
            </div>
          </div>

          {/* Product Details */}
          {/* Product Details */}
          <div className="card shadow-sm mt-4">
            <div className="card-header p-3 bg-light">
              <h5 className="mb-0 text-black fw-bold">
                Product Details
              </h5>
            </div>
            <div className="card-body">
              {/* {orderData ? ( */}
              {/* orderData.products.map((product, index) => ( */}
              <div className="row mb-4 border-bottom pb-3">
                <div className="col-md-4">
                  <img
                    src={`${SITE_URL}/images/product/${JSON.parse(orderData.images || '[]')[0]}`}
                    alt={orderData.productName}
                    className="img-fluid rounded border"
                    style={{ maxHeight: "200px", objectFit: "cover" }}
                  />
                </div>
                <div className="col-md-8">
                  <h5 className="text-primary">{orderData.productName}</h5>
                  <p className="text-muted">{orderData.short_description}</p>
                  <p className="mb-1">
                    <strong>MRP:</strong>{" "}
                    <span className="text-decoration-line-through">
                      {currencies?.symbol} {orderData.mrp}
                    </span>
                  </p>
                  <p className="mb-1">
                    <strong>Selling Price:</strong>{" "}
                    <span className="text-success">{currencies?.symbol} {orderData.sales_rate}</span>
                  </p>
                  <p className="mb-1">
                    <strong>Quantity:</strong> {orderData.qty}
                  </p>
                  <p className="mb-0 fw-bold">
                    Total: {currencies?.symbol} {(orderData.sales_rate * orderData.qty).toFixed(2)}
                  </p>
                </div>
              </div>
            </div>
          </div>
          {/* Order Summary */}
          <div className="card shadow-sm mt-4">
            <div className="card-header p-3 bg-light">
              <h5 className="mb-0 text-black fw-bold">Order Summary</h5>
            </div>
            <div className="card-body">

              <div className="d-flex justify-content-between mb-2">
                <span>Selling Price:</span>
                <span>
                  {currencies?.symbol} {orderData.sales_rate}
                </span>
              </div>
              <div className="d-flex justify-content-between mb-2">
                <span>Quantity:</span>
                <span>
                  {orderData.qty}
                </span>
              </div>
              <div className="d-flex justify-content-between fw-bold border-top pt-2">
                <span>Grand Total:</span>
                <span>{currencies?.symbol} {(orderData.amount * orderData.qty).toFixed(2)}</span>
              </div>
            </div>
          </div>


          {/* Customer Details */}
          <div className="card shadow-sm mt-4">
            <div className="card-header bg-light p-3 text-black">
              <h5 className="mb-0">
                Customer Details
              </h5>
            </div>
            <div className="card-body">
              <div className="row">
                <div className="col-md-6">
                  <p className="mb-2">
                    <strong>Name:</strong>
                    <span className="ms-2">{orderData.name || orderData.username}</span>
                  </p>
                  <p className="mb-2">
                    <strong>Email:</strong>
                    <span className="ms-2">{orderData.email || 'N/A'}</span>
                  </p>
                </div>
                <div className="col-md-6">
                  <p className="mb-2">
                    <strong>Phone:</strong>
                    <span className="ms-2">{orderData.phone || orderData.address?.phone || 'N/A'}</span>
                  </p>
                </div>
              </div>


              {orderData.address && (
                <div className="mt-3">
                  <strong>Address:</strong>
                  <div className="bg-light p-3 rounded mt-2 text-dark">
                    {orderData?.address?.name},<br/>{orderData?.address?.address},<br/>
                    {orderData?.address?.locality},Pin : {orderData?.address?.pincode},<br/>
                    Phone : {orderData.address?.phone}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>

        {/* Status Update Panel */}
        <div className="col-lg-4">
          <div className="card shadow-sm sticky-top" style={{ top: '90px' }}>
            <div className="card-header bg-light p-3 text-dark">
              <h5 className="mb-0">
                Update Order Status
              </h5>
            </div>
            <div className="card-body">
              <div className="mb-4">
                <strong>Current Status:</strong>
                <div className="mt-2">
                  <span className={`badge ${getStatusBadgeClass(orderData.order_status)} fs-6 px-3 py-2`}>
                    {getCurrentStatusText(orderData.order_status)}
                  </span>
                </div>
              </div>

              {(orderData.order_status !== 4 && orderData.order_status !== 7 && orderData.order_status !== 5) ? (
                <>
                  <div className="mb-4">
                    <label className="form-label fw-bold">Select New Status:</label>
                    <div className="status-options">
                      {statusOptions.map((status) => (
                        <div key={status.value} className="form-check mb-2">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="orderStatus"
                            id={`status-${status.value}`}
                            value={status.value}
                            checked={selectedStatus === status.value}
                            onChange={handleStatusChange}
                            disabled={statusLoading}
                          />
                          <label
                            className={`form-check-label ${status.color} fw-semibold`}
                            htmlFor={`status-${status.value}`}
                          >
                            {status.label}
                          </label>
                        </div>
                      ))}
                    </div>
                  </div>

                  {(selectedStatus !== parseInt(orderData.order_status)) && (
                    <div className="alert alert-info">
                      <small>
                        Status will be changed from <strong>{getCurrentStatusText(orderData.order_status)}</strong> to <strong>{statusOptions.find(s => s.value === selectedStatus)?.label}</strong>
                      </small>
                    </div>
                  )}

                  <button
                    type="button"
                    className="btn btn-primary w-100"
                    onClick={handleStatusUpdate}
                    disabled={isStatusUpdateDisabled()}
                  >
                    {statusLoading ? (
                      <>
                        <span className="spinner-border spinner-border-sm me-2" role="status"></span>
                        Updating...
                      </>
                    ) : (
                      <>
                        Update Status
                      </>
                    )}
                  </button>
                </>
              ) : (
                <div className="alert alert-warning">
                  <strong>Status Update Unavailable</strong>
                  <br />
                  <small>This order has reached a final status and cannot be modified.</small>
                </div>
              )}
            </div>
          </div>

          {/* Order Timeline */}

        </div>
      </div>
    </div>
  );
};

export default OrderDetailsPage;